var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('catalog-search'),_vm._v(" "),_c('catalog-stories'),_vm._v(" "),_c('catalog-products')],1)}
var staticRenderFns = []

export { render, staticRenderFns }